module.exports = __webpack_public_path__ + "img/detailingDomonetization.b9e640be.png";